// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"30b4c473","977":"2754e49f"}[chunkId] + ".chunk.js";
};